<template>
  <button @click="$emit('showTagPopup')" class="btn tag-trigger-button">test</button>
</template>

<script>
export default {
  name: "TagTriggerBtn"
}
</script>

<style scoped>
.tag-trigger-button{
  margin-left: 10px;
}
</style>